import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import BudgetComponent from './Budget'
import DetailComponent from './Detail'
import ProviderComponent from './Providers'


function TabPanel(props) {

  const { children, value, index, ...other } = props;


  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}

    >
      {value === index && <Box p={3} style={{paddingTop: '0px', minHeight:'20px'}}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}


function TabsScrollable(props) {
	
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	
	const [value, setValue] = React.useState(0);

	return (
		<React.Fragment>
			<AppBar position="static" color="default">
				<Tabs
				  value={value}
				  onChange={handleChange}
				  indicatorColor="primary"
				  textColor="primary"
				  variant="scrollable"
				  scrollButtons="auto"
				  aria-label="scrollable auto tabs example"
				  style={{minHeight: '20px'}}
				>
					<Tab label="Detalle" {...a11yProps(0)} style={{minHeight: '20px'}} />
					<Tab label="Presupuesto" {...a11yProps(1)} style={{minHeight: '20px'}}  />
					<Tab label="Proveedores" {...a11yProps(2)} style={{minHeight: '20px'}}  />
					<Tab label="Comprobantes" {...a11yProps(3)} style={{minHeight: '20px'}}  />
					<Tab label="Relaciones" {...a11yProps(4)} style={{minHeight: '20px'}}  />
					<Tab label="Historia" {...a11yProps(5)} style={{minHeight: '20px'}}  />
					<Tab label="Archivos adjuntos" {...a11yProps(6)} style={{minHeight: '20px'}}  />
					<Tab label="Mensajes" {...a11yProps(7)} style={{minHeight: '20px'}}  />
				</Tabs>
				</AppBar>
				<TabPanel value={value} index={0}>
					<DetailComponent save={props.save}/>
				</TabPanel>
				<TabPanel value={value} index={1}>
					<BudgetComponent />
				</TabPanel>
				<TabPanel value={value} index={2}>
					<ProviderComponent />
				</TabPanel>
		</React.Fragment>
	)

}

export default TabsScrollable;